import Button from '@platform-ui-common/components/Button/index.js';
import Color from '@platform-ui-common/utilities/Color.js';
import { useCallback } from 'react';
import useSnackbar, { SnackbarKey } from './useSnackbar/index.js';

export default function useSaveIndicator(): () => void {
  const { showSnackbar, removeSnackbar } = useSnackbar();
  return useCallback(
    (): SnackbarKey =>
      showSnackbar('All changes saved!', (key: SnackbarKey) => (
        <Button variant="text" textColor={Color.Link} onClick={() => removeSnackbar(key)}>
          Dismiss
        </Button>
      )),
    [showSnackbar, removeSnackbar],
  );
}
